import { createErrorBoundaryForDomain } from 'lib/error/utils/createErrorBoundaryForDomain';

export const ErrorBoundary = createErrorBoundaryForDomain('Content');

const module = {
  ErrorBoundary,
};

export default module;
